import $ from 'jquery'
import { TimelineMax, TweenMax } from 'gsap'

export default {
  init() {
    if ($('.js-popin-open')) {
      TweenMax.set('.popinEntries__popin', {
        autoAlpha: 0
      })

      TweenMax.set('.popinEntries__popin-pane', {
        x: '-100%'
      })

      TweenMax.set('.popinEntries__item-closeBtn', {
        autoAlpha: 0
      })

      let scrollTop, scrollLeft

      function disableScroll() { 
        scrollTop = window.pageYOffset || document.documentElement.scrollTop
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
        
        window.onscroll = function() { 
          window.scrollTo(scrollLeft, scrollTop)
        }
      } 
        
      function enableScroll() { 
        window.onscroll = function() {}; 
      } 

      $('.js-popin-open').on('click', function() {
        $('.header').addClass('header--popinOpen')
        
        const $popin = $(this).closest('.js-popin-parent').find('.popinEntries__popin')
        const tl = new TimelineMax()
        disableScroll()

        tl.to($popin, .5, {
          autoAlpha: 1
        })

        tl.to($popin.find('.popinEntries__popin-pane'), .5, {
          x: 0,
          onStart: () => {
            TweenMax.to('.popinEntries__item-closeBtn', .5, {
              autoAlpha: 1
            })
          }
        }, '-=.2')
      })

      const closePopin = () => {
        enableScroll()
        const tl = new TimelineMax()

        tl.to('.popinEntries__popin-pane', .5, {
          x: '-100%',
          onStart: () => {
            TweenMax.to('.popinEntries__item-closeBtn', .5, {
              autoAlpha: 0
            })
          }
        })

        tl.to('.popinEntries__popin', .5, {
          autoAlpha: 0,
          onComplete: () => {
            $('.header').removeClass('header--popinOpen')
          }
        }, '-=.2')
      }

      $('.popinEntries__popin').on('click', closePopin)
      $('.popinEntries__popin-pane').on('click', e => e.stopPropagation())
      $('.popinEntries__popin-backBtn').on('click', closePopin)
      $('.popinEntries__item-closeBtn').on('click', closePopin)
    }
  },  
  finalize() {

  }
};
